<template>
  <div
    v-if="canViewFedsfm"
    class="row fsb-danger-block"
  >
    <div class="col-md-12 col-xs-12">
      <div class="fsb-danger">
        <img :src="'../../../../public/img/' + fedSfm.category + '.png'" class="icon-fsb" alt="" />
        <div class="fsb-danger-info">
          <strong>Внимание!</strong>
          <span v-html="fedSfm.info"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlacklistNotification',

  props: {
    visitor: {
      type: Object,
      required: true
    },
    isView: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    canViewFedsfm () {
      return this.fedSfm && this.isView
    },

    fedSfm () {
      return this.visitor.personal.fedSfm
    }
  }
}
</script>
